import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { t } from '../locales/translate.js';
import Select from 'react-select';

function Element({ apiCall, user }) {

  const [reports, setReports] = useState([]);
  const [error, setError] = useState(null);
  //loading
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedTime, setSelectedTime] = useState('all');
  const [selectedOrgan, setSelectedOrgan] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchHunterQuery, setSearchHunterQuery] = useState('');
  const [openAuthorIndexes, setOpenAuthorIndexes] = useState([]);
  const [noUserMustRedirect, setNoUserMustRedirect] = useState(false);
  const [sort, setSort] = useState({ field: '', order: '' });

  const options = [
    { value: 'delivered', label: t('delivered') },
    { value: 'picked_up', label: t('picked_up') },
    { value: 'undressed', label: t('undressed') },
    { value: 'weighed', label: t('weighed') },
    { value: 'received_malmo', label: t('received_malmo') },
    { value: 'awaiting_return', label: t('awaiting_return') },
    { value: 'ready', label: t('ready') },
    { value: 'scrapped', label: t('scrapped') },
  ];

  // Map selected values to option objects for react-select
  const selectedStatusOptions = options.filter(o => selectedStatus.includes(o.value));

  const filterStatus = (status) => {
    if (user?.role_id === 2 || user?.role_id === 4) { // Depot or Hunter

      if (status === 'Avklädd' || status === 'Utvägd' || status === 'Mottagen Malmö' || status === 'Utvägd') {
        return 'Upphämtad';
      }
    }

    return status;
  }

  const statusBadgeClass = (status) => {
    const displayStatus = filterStatus(status);
    if (displayStatus === 'Inlämnad' || displayStatus === 'Upphämtad') return 'badge badge-warning';
    if (displayStatus === 'Väntar på återtag') return 'badge badge-orange';
    if (displayStatus === 'Klar') return 'badge badge-success';
    if (displayStatus === 'Kasserad') return 'badge badge-danger';
    return 'badge badge-secondary';
  }

  const applySort = (field) => {
    if (field === 'hunter') {
      setSort({ field: 'hunter', order: sort.order === 'asc' ? 'desc' : 'asc' });
      setReports(reports.slice().sort((a, b) => {
        const aValue = a.author_name || '';
        const bValue = b.author_name || '';
        return sort.order === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
      }));
    } else if (field === 'date') {
      setSort({ field: 'date', order: sort.order === 'asc' ? 'desc' : 'asc' });
      setReports(reports.slice().sort((a, b) => {
        const aValue = new Date(a.created_at) || 0;
        const bValue = new Date(b.created_at) || 0;
        return sort.order === 'asc' ? aValue - bValue : bValue - aValue;
      }));
    }
  }

  const clearSearch = (e) => {
    e.preventDefault();
    setSearchQuery('');
    console.log('Search query cleared');
    fetchReports(true);
  }

  const clearHunterSearch = (e) => {
    e.preventDefault();
    setSearchHunterQuery('');
    console.log('Hunter search query cleared');
    fetchReports(true);
  }

  useEffect(() => {
    setLoading(true);
    // Fetch reports data when the component mounts
    if (user?.id) {
      fetchReports();
    } else {
      // just in case wait for a 3 seconds, and if there's still no user - redirect to /login
      setNoUserMustRedirect(true);
      setTimeout(() => {
        console.log(user);
        if (!user?.id) {
          if (noUserMustRedirect) {
            console.log('No user found, redirecting to /login');
            window.location.href = '/login';
          }
        }
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiCall, selectedStatus, selectedTime, selectedOrgan]); // Dependencies for useEffect


  const fetchReports = (clearSearch = false) => {

    let search = searchQuery;
    let hunterSearch = searchHunterQuery;
    if (clearSearch) {
      search = '';
      hunterSearch = '';
    }

    const statusFilter = (Array.isArray(selectedStatus) && selectedStatus.length) ? selectedStatus : 'all';
    apiCall("GET", "reports", { status: statusFilter, time: selectedTime, organ: selectedOrgan, search: search, hunterSearch: hunterSearch })
      .then(({ response, error }) => {
        if (error) {
          console.error("Error fetching reports:", error);
          setError(error);
        } else {
          setReports(response || []);
          setError(null);
          setLoading(false);
          console.log('Request:', { status: statusFilter, time: selectedTime, organ: selectedOrgan, search: searchQuery });
          console.log("Fetched reports:", response);
          setNoUserMustRedirect(false);
        }

      });

  }

  // Fetch reports data when the selected status or time changes

  if (loading) {
    return <div>{t('loading')}</div>;
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        <i className="fa-solid fa-exclamation-triangle"></i> {error}
      </div>
    );
  }

  // Render the list of reports
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5>{t('reports')}</h5>

        <div className="search">
          <div className="dt-search d-inline-block">
            <input
              type="text"
              className="dt-input form-control"
              placeholder={t('search_reports')}
              value={searchQuery}
              onChange={(e) => { setSearchQuery(e.target.value) }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  if (searchQuery && searchQuery.length >= 2) {
                    fetchReports();
                  }
                }
              }}
            />
            <i className="fa-solid fa-magnifying-glass" onClick={() => {
              if (searchQuery && searchQuery.length >= 2) {
                fetchReports();
              }
            }} />
          </div>

          {searchQuery && (<a onClick={(e) => { clearSearch(e) }} className="clear-search">
            <i className="fa-solid fa-xmark"></i>
          </a>)}
        </div>

        {user?.role_id === 4 && (
          <div className="search">
            <div className="dt-search d-inline-block">
              <input
                type="text"
                className="dt-input form-control"
                placeholder={t('search_hunters')}
                value={searchHunterQuery}
                onChange={(e) => { setSearchHunterQuery(e.target.value) }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    if (searchHunterQuery && searchHunterQuery.length >= 2) {
                      fetchReports();
                    }
                  }
                }}
              />
              <i className="fa-solid fa-magnifying-glass" onClick={() => {
                if (searchHunterQuery && searchHunterQuery.length >= 2) {
                  fetchReports();
                }
              }} />
            </div>

            {searchHunterQuery && (<a onClick={(e) => { clearHunterSearch(e) }} className="clear-search">
              <i className="fa-solid fa-xmark"></i>
            </a>)}
          </div>
        )}

        {user?.role_id !== 4 && (<Select
          options={options}
          isMulti
          placeholder={'Välj...'}
          value={selectedStatusOptions}
          onChange={(vals) => setSelectedStatus(vals ? vals.map(v => v.value) : [])}
        />)}

        <div className="dt-length d-inline-block dropdown-product" onChange={(e) => setSelectedTime(e.target.value)}>
          <select name="depots" aria-controls="roles-permission" className="dt-input form-select" >
            <option value="all">{t('all_dates')}</option>
            <option value="this_month"
              selected={selectedTime === 'this_month'}
            >{t('this_month')}</option>
            <option value="this_quarter"
              selected={selectedTime === 'this_quarter'}
            >{t('this_quarter')}</option>
            <option value="ytd"
              selected={selectedTime === 'ytd'}
            >{t('ytd')}</option>
            <option value="last_year"
              selected={selectedTime === 'last_year'}
            >{t('last_year')}</option>
          </select>
        </div>

        <Link to="/add" className="btn btn-primary">
          <i className="fa-solid fa-plus"></i> {t('new_report')}
        </Link>
      </div>

      <div className="card-body projects-wrapper" >
        <div className="row g-4">
          {!reports.length && !user?.id && (
            <div className="col-12">
              {t('no_reports_available_register_or_signin')}
            </div>
          )}

          {error && (
            <div className="col-12">
              <div className="alert alert-danger" role="alert">
                <i className="fa-solid fa-exclamation-triangle"></i> {error}
              </div>
            </div>
          )}

          {!reports.length && user?.id && (
            <div className="col-12">
              {t('no_reports_available_create_new')}
            </div>
          )}

          {reports.map((report, index) => (
            <div className="col-xxl-3 col-md-6 col-ed-4 box-col-6 mobile-only" key={index}>
              <div className="kanban-item">
                <div className="kanban-box">
                  <span className="date">
                    <span className="">

                      {report.created_at ? new Date(report.created_at).toISOString().split('T')[0] : t('not_available')}
                    </span>
                    {report.game_qr ? (
                      <span className="">
                        <i className="fa-solid fa-barcode"></i> {report.game_qr}
                      </span>) : (
                      <span className="">
                        <i className="fa-solid fa-barcode"></i> {report.organ_qr}
                      </span>
                    )}
                  </span>
                  <span className={`${statusBadgeClass(report.statusName)} f-right`}>{filterStatus(report.statusName)}</span>
                  <h6>{report.game_name}</h6>
                  <div className="common-align">
                    <div className="flex-grow-1 note">
                      <p>{report.notes}</p>
                    </div>
                  </div>
                  <div className="d-flex mt-3">
                    <ul className="list">

                      <li data-bs-toggle="tooltip" data-bs-placement="bottom"><i className="fa-solid fa-home"></i>
                        {report?.depot?.name}
                      </li>

                      {report.statusName == 'Klar' && report.weight && (
                        <li data-bs-toggle="tooltip" data-bs-placement="bottom" >
                          {report.weight} <span className="unit">kg</span>
                        </li>
                      )}

                      <li data-bs-toggle="tooltip" data-bs-placement="bottom">
                        {report.price_per_kg
                          ? (<>{report.price_per_kg} <span className="unit">kr/kg</span></>)
                          : (user?.role_id === 2 && report.depot?.independent == 1)
                            ? (<span title={t('price_handled_by_depot')}>—</span>)
                            : t('not_available')}
                      </li>

                      {report.statusName == 'Klar' && report.price_per_kg && (
                        <li data-bs-toggle="tooltip" data-bs-placement="bottom">
                          {(report.weight * report.price_per_kg).toLocaleString().replace(/,/g, ' ')} <span className="unit">kr</span>
                        </li>
                      )}
                    </ul>
                    <ul className="common-f-start mt-2">
                      {report?.images && report.images.length > 0 && report.images.map((image, imgIndex) => (
                        <li data-bs-toggle="tooltip" data-bs-placement="top" key={imgIndex}>
                          <a href={`${process.env.REACT_APP_API_HOST}/storage/${image}`} target="_blank" rel="noopener noreferrer">
                            <img className=" common-circle" src={`${process.env.REACT_APP_API_HOST}/storage/${image}`} alt={imgIndex + 1} />
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {user?.role_id === 4 && report?.author_name && (
                    <div className="mobile-author-info mt-3 pt-2 border-top">
                      <div
                        className="d-flex justify-content-between align-items-center"
                        role="button"
                        onClick={() => {
                          if (openAuthorIndexes.includes(index)) {
                            setOpenAuthorIndexes(openAuthorIndexes.filter(i => i !== index));
                          } else {
                            setOpenAuthorIndexes([...openAuthorIndexes, index]);
                          }
                        }}
                      >
                        <span>
                          <i className="fa-solid fa-user me-2"></i>
                          {report.author_name}
                        </span>
                        <i className={`fa-solid fa-chevron-${openAuthorIndexes.includes(index) ? 'up' : 'down'}`}></i>
                      </div>

                      {openAuthorIndexes.includes(index) && (
                        <ul className="list-unstyled small mt-2 mb-0">
                          {report?.author_phone && (
                            <li>
                              <strong>{t('author_phone')}:</strong>{' '}
                              <a href={`tel:${report.author_phone}`}>{report.author_phone}</a>
                            </li>
                          )}
                          {report?.author_email && (
                            <li>
                              <strong>{t('email')}:</strong>{' '}
                              <a href={`mailto:${report.author_email}`}>{report.author_email}</a>
                            </li>
                          )}
                          {report?.author_bank_account && (
                            <li><strong>{t('bank_account')}:</strong> {report.author_bank_account}</li>
                          )}
                          {report?.author_bank_account_name && (
                            <li><strong>{t('bank_account_name')}:</strong> {report.author_bank_account_name}</li>
                          )}
                        </ul>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}

          <div className="container-fluid user-list-wrapper desktop-only ">
            <div className="row">
              <div className="col-12">
                <div>
                  <div className="card-body pt-0 px-0">
                    <div className="list-product user-list-table">
                      <div className="table-responsive custom-scrollbar">
                        <div id="roles-permission_wrapper" className="dt-container dt-empty-footer"><div className="dt-layout-row">
                          <div className="dt-layout-cell dt-start ">
                            <div className="dt-length">
                              <label for="dt-length-0">{t('entries_per_page')}</label>
                            </div>
                          </div>

                        </div>
                          <div className="dt-layout-row dt-layout-table">
                            <div className="dt-layout-cell ">
                              <table className="table dataTable" id="roles-permission" aria-describedby="roles-permission_info">
                                <thead>
                                  <tr role="row">
                                    <th data-dt-column="1" rowspan="1" colspan="1" >
                                      <span className="dt-column-title" role="button">
                                        <span className="c-o-light f-w-600">{t('game_id')}</span>
                                      </span>
                                    </th>

                                    <th data-dt-column="1" rowspan="1" colspan="1" >
                                      <span className="dt-column-title" role="button">
                                        <span className={`c-o-light f-w-600 ${sort.field === 'date' ? `bold` : ''}`}>{t('delivery_date')}</span>
                                        <span className="sort" role="button" onClick={() => applySort('date')}>
                                          <i className={`fa-solid fa-arrow-${sort.field === 'date' && sort.order === 'asc' ? 'up' : 'down'}-wide-short`}></i>
                                        </span>
                                      </span>
                                    </th>

                                    {user?.role_id !== 4 && (<th data-dt-column="1" rowspan="1" colspan="1" >
                                      <span className="dt-column-title" role="button">
                                        <span className="c-o-light f-w-600">{t('depot')}</span>
                                      </span>
                                    </th>)}

                                    {user?.role_id === 4 && (<th data-dt-column="1" rowspan="1" colspan="1" >
                                      <span className="dt-column-title" role="button">
                                        <span className={`c-o-light f-w-600 ${sort.field === 'hunter' ? `bold` : ''}`}>{t('hunter')}</span>
                                        <span className="sort" role="button" onClick={() => applySort('hunter')}>
                                          <i className={`fa-solid fa-arrow-${sort.field === 'hunter' && sort.order === 'asc' ? 'up' : 'down'}-wide-short`}></i>
                                        </span>
                                      </span>
                                    </th>)}


                                    <th data-dt-column="1" rowspan="1" colspan="1" >
                                      <span className="dt-column-title" role="button">
                                        <span className="c-o-light f-w-600">{t('status')}</span>
                                      </span>
                                    </th>

                                    <th data-dt-column="1" rowspan="1" colspan="1" >
                                      <span className="dt-column-title" role="button">
                                        <span className="c-o-light f-w-600">{t('game')}</span>
                                      </span>
                                    </th>

                                    <th data-dt-column="1" rowspan="1" colspan="1" >
                                      <span className="dt-column-title" role="button">
                                        <span className="c-o-light f-w-600">{t('weight')}</span>
                                      </span>
                                    </th>

                                    <th data-dt-column="1" rowspan="1" colspan="1" >
                                      <span className="dt-column-title" role="button">
                                        <span className="c-o-light f-w-600">{t('price_per_kg')}</span>
                                      </span>
                                    </th>

                                    <th data-dt-column="1" rowspan="1" colspan="1" >
                                      <span className="dt-column-title" role="button">
                                        <span className="c-o-light f-w-600">{t('sum_kr')}</span>
                                      </span>
                                    </th>

                                    <th data-dt-column="1" rowspan="1" colspan="1" >
                                      <span className="dt-column-title" role="button">
                                        <span className="c-o-light f-w-600">{t('images')}</span>
                                      </span>
                                    </th>

                                    <th data-dt-column="1" rowspan="1" colspan="1" >
                                      <span className="dt-column-title" role="button">
                                        <span className="c-o-light f-w-600">{t('note')}</span>
                                      </span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {reports.map((report, index) => (
                                    <tr className="product-removes inbox-data" key={index}>
                                      <td>
                                        {report.game_qr}
                                        {report.organ_qr && <i className="fa-solid fa-heart"></i>}
                                      </td>
                                      <td>
                                        {report.created_at ? report.created_at.split('T')[0] : t('not_available')}
                                      </td>
                                      {user?.role_id !== 4 && (
                                        <td>
                                          {report?.depot?.name || t('not_available')}
                                        </td>
                                      )}

                                      {user?.role_id === 4 && (
                                        <td className={`author-column${openAuthorIndexes.includes(index) ? ' open' : ''}`}>
                                          {report?.author_name}
                                          <span className="toggle" onClick={() => {
                                            if (openAuthorIndexes.includes(index)) {
                                              setOpenAuthorIndexes(openAuthorIndexes.filter(i => i !== index));
                                            } else {
                                              setOpenAuthorIndexes([...openAuthorIndexes, index]);
                                            }
                                          }}>
                                            <i className="fa-solid fa-chevron-down"></i>
                                          </span>
                                          <span className="bank-data">
                                            {report?.author_phone && (<>
                                              <span className="title">{t('author_phone')}</span>
                                              <span className="value">{report?.author_phone}</span>
                                            </>)}
                                            {report?.author_email && (<>
                                              <span className="title">{t('email')}</span>
                                              <span className="value">{report?.author_email}</span>
                                            </>)}
                                            {report?.author_bank_account && (<>
                                              <span className="title">{t('bank_account')}</span>
                                              <span className="value">{report?.author_bank_account}</span>
                                            </>)}
                                            {report?.author_bank_account_name && (<>
                                              <span className="title">{t('bank_account_name')}</span>
                                              <span className="value">{report?.author_bank_account_name}</span>
                                            </>)}
                                          </span>
                                        </td>
                                      )}

                                      <td> <span className={statusBadgeClass(report.statusName)}>
                                        {filterStatus(report.statusName)}
                                      </span></td>
                                      <td>
                                        {report.game_name}
                                      </td>
                                      <td>
                                        {report.statusName != 'Klar' ? '-' : report.weight}
                                      </td>
                                      <td>
                                        {report.price_per_kg
                                          ? `${report.price_per_kg} kr`
                                          : (user?.role_id === 2 && report.depot?.independent == 1)
                                            ? (<span title={t('price_handled_by_depot')}>—</span>)
                                            : t('not_available')}
                                      </td>

                                      <td>
                                        {/* number format with space for thousands */}
                                        {report.statusName == 'Klar' && report.price_per_kg
                                          ? (report.weight * report.price_per_kg).toLocaleString().replace(/,/g, ' ') + ' kr'
                                          : (user?.role_id === 2 && report.depot?.independent == 1)
                                            ? (<span title={t('price_handled_by_depot')}>—</span>)
                                            : '-'}
                                      </td>

                                      <td>
                                        {report?.images && report.images.map((image, imgIndex) => (
                                          <a key={imgIndex} href={`${process.env.REACT_APP_API_HOST}/storage/${image}`} target="_blank" rel="noopener noreferrer">
                                            <img className="common-circle" src={`${process.env.REACT_APP_API_HOST}/storage/${image}`} alt={imgIndex + 1} />
                                          </a>
                                        ))}
                                      </td>
                                      <td className="notecolumn">
                                        {report?.notes?.substring(0, 50)}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                                <tfoot></tfoot></table></div></div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>

      </div>
    </div>

  );
}

export default Element;
